import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class AdminUserGroupEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "AdminUserGroup";
        this.primaryEnterpriseComponent = "AdminUserGroup";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminUserGroup";
        eom.enterpriseComponent = "AdminUserGroup";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "AdminUserGroupEmployee";
        eom.enterpriseComponent = "AdminUserGroupEmployee";
        eom.relationship = "AdminUserGroupAdminUserGroupEmployee";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default AdminUserGroupEnterpriseObjectMetadata;